// extracted by mini-css-extract-plugin
export default {"title_box":"koeranAppComponent_title_box__XFS93","img_box":"koeranAppComponent_img_box__JtpDP","line":"koeranAppComponent_line__qUCrr","app":"koeranAppComponent_app__scYNt"};